(function (angular) {
	"use strict";

	function EditRolesForm(scope) {
		var self = this;
		var formName = "edit-roles-form";

		var _protected = BaseForm.call(self, formName, scope);

		self.save = function () {
			var defer = $q.defer();

			if (self.validator.validate()) {
                for (var i in self.formData.roles.roles) {
                    var role = self.formData.roles.roles[i];

                    if (role.cost_center) {
                        var cost_center = role.cost_center;
                        cost_center.value = cost_center.value || {};

                        if (!cost_center.value.id) {
                            delete cost_center.value;
                        } else {
                            cost_center.value.id = parseInt(cost_center.value.id);
                        }
                    }
                }

				defer.resolve(self.formData.roles);
			}
			else {
				defer.reject({});
			}

			return defer.promise;
		};

		/**
		 * load the data required for the form
		 * @param formData
		 * @param newPosition - start editing and add new position or not
		 */
		self.load = function (formData, newPosition) {

			self.formData = formData;
			self.formData.roles = self.formData.roles || {};
            self.formData.roles.roles = self.formData.roles.roles || [];

			for (var i in self.formData.roles.roles) {
			    var role = self.formData.roles.roles[i];

			    if (role.cost_center) {
                    var cost_center = role.cost_center;
                    cost_center.value = cost_center.value || {};

                    if (cost_center.value.id) {
                        cost_center.value.id += "";
                    }
                }
            }

			if (newPosition)
				self.addPosition();
			try {
				scope.$digest();
			} catch (e) {
			}

		};

		self.deletePosition = function (index) {
			self.formData.roles.roles.splice(index, 1);
		};

		self.addPosition = function () {
			self.formData.roles.roles = self.formData.roles.roles || [];
			self.formData.roles.roles.push({id: Date.now(), pay_rate: {}, position: {category: {}}, allow_rate_access: true});
		};

		self.validator.validateCustom = function (field, optionsField, rule) {

		    var fieldIndex = optionsField.attr("validate-index");
		    var name = field.attr("name");

		    switch (rule.name) {
                case "required-if-rate":
                    var roleRate = _.findWhere(self.formData.roles.roles, {id: parseInt(fieldIndex)}) || {};
                    var isADPRate = self.formData.isADPRate;
                    var rate = (isADPRate) ? (roleRate.pay_rate && roleRate.pay_rate.pay_rate_code) : roleRate.pay_rate;
                    var position = roleRate.position;

                    rate = rate || {};

                    return !(!!(Object.keys(rate).length && !position.code));
            }

            return true;
        };
	}

	angular
			.module('harriApp')
			.service('EditRolesForm', [function () {

				return function (scope) {
					return new EditRolesForm(scope);
				}
			}]);

})(angular);